/**
 * Публичные медиа лежат в /tabs/..., не в /adminka_project/tabs/...
 * Нормализует path из ответа API (например ortezdeti.ru/adminka_project/tabs/ → ortezdeti.ru/tabs/).
 */
export const normalizePublicMediaPath = (path) => {
  if (path == null || typeof path !== 'string') return path;

  return path.replace(/(^|\/)adminka_project\//g, '$1');
};

const normalizeItemPath = (item) => {
  if (!item || typeof item !== 'object') return item;
  if (!Object.prototype.hasOwnProperty.call(item, 'path')) return item;

  return {
    ...item,
    path: normalizePublicMediaPath(item.path),
  };
};

/**
 * Рекурсивно нормализует поля path в tabs / others / вложенных публикациях.
 */
export const normalizeSiteDataMediaPaths = (data) => {
  if (!data || typeof data !== 'object') return data;

  const normalizeCollection = (collection) => {
    if (!Array.isArray(collection)) return collection;

    return collection.map((item) => {
      if (!item || typeof item !== 'object') return item;

      const normalized = normalizeItemPath(item);
      const next = { ...normalized };

      if (Array.isArray(normalized.publications)) {
        next.publications = normalized.publications.map(normalizeItemPath);
      }

      return next;
    });
  };

  return {
    ...data,
    tabs: normalizeCollection(data.tabs),
    others: normalizeCollection(data.others),
  };
};

export default normalizePublicMediaPath;
